import classes from './ErrorPlaceholder.module.scss'
import { FiAlertCircle } from 'react-icons/fi'

interface Props {
  message: string
}

const CustomErrorPlaceholder = ({
  message
}: Props) => (
  <div className={classes.ErrorMessage}>
    <FiAlertCircle
      aria-hidden
      className={classes.ErrorIcon}
      size='12px'
    />
    <span>{message}</span>
  </div>
)

export default CustomErrorPlaceholder
